export default __webpack_public_path__ + "static/media/policeman.3f52e945.svg";